import uiCopy from './service-ui-copy.json';
(() => {
  'use strict';
  if (/(^|\/)[^/]*rolex[^/]*(\/|$)/i.test(window.location.pathname)) return;
  const root = document.getElementById('service-page');
  if (!root) return;
  const locale = root.dataset.svLocale === 'fr' ? 'fr' : 'en';
  const copy = uiCopy[locale];
  const locations = {
    Cambridge: {phone:'(519) 740-7720', tel:'+15197407720', name:'Cambridge', address:['299 Hespeler Road','Cambridge, ON N1R 3H8']},
    'Conestoga Mall': {phone:'(519) 747-2444', tel:'+15197472444', name:'Waterloo', address:['550 King Street North, Unit B7','Waterloo, ON N2L 5W6']}
  };
  const selectors = [...root.querySelectorAll('[data-sv-location]')];
  const brand = document.getElementById('sv-watch-brand');
  const guidance = root.querySelector('[data-sv-guidance]');
  const restrictedBrands = new Set(['Rolex','TUDOR','OMEGA','Zenith']);
  let selectedLocation = 'Cambridge';
  function syncLocation(value) {
    if (!locations[value]) return;
    const restricted = restrictedBrands.has(brand?.value);
    selectedLocation = restricted ? 'Cambridge' : value;
    const info = locations[selectedLocation];
    for (const select of selectors) {
      select.value = selectedLocation;
      const waterloo = select.querySelector('option[value="Conestoga Mall"]');
      if (waterloo) waterloo.disabled = restricted;
    }
    root.querySelectorAll('[data-sv-call]').forEach(a => {a.href='tel:'+info.tel;a.querySelector('span').textContent=copy.call+' '+info.phone;});
    root.querySelectorAll('[data-sv-call-mobile]').forEach(a => {a.href='tel:'+info.tel;a.querySelector('span').textContent=copy.call+' '+info.name;});
    root.querySelectorAll('[data-sv-phone-text]').forEach(a => {a.href='tel:'+info.tel;a.textContent=info.phone;});
    root.querySelectorAll('[data-sv-address]').forEach(p => {p.replaceChildren(document.createTextNode(info.address[0]),document.createElement('br'),document.createTextNode(info.address[1]));});
    if (guidance && brand) guidance.textContent = restricted ? copy.restrictedGuidance.replace('{brand}', brand.value) : copy.guidance;
  }
  selectors.forEach(select => select.addEventListener('change',()=>syncLocation(select.value)));
  brand?.addEventListener('change',()=>syncLocation(selectedLocation));
  syncLocation(selectedLocation);
  const form=document.getElementById('sv-enquiry'), submit=document.getElementById('sv-submit'), status=document.getElementById('sv-status');
  const csrf=form.querySelector('input[name="_csrf"]')?.value?.trim();
  const api=window.RaffiServiceRequests;
  let sending=false, sent=false;
  function label() {submit.textContent=form.elements.contactMethodPreference.value==='Email'?copy.send:copy.callback;}
  form.querySelectorAll('[name="contactMethodPreference"]').forEach(input=>input.addEventListener('change',label));
  function show(text, error=false) {status.textContent=text;status.hidden=false;status.setAttribute('role',error?'alert':'status');}
  form.addEventListener('input',event=>event.target.setCustomValidity?.(''));
  form.addEventListener('change',event=>event.target.setCustomValidity?.(''));
  if (!csrf || !api) {
    show(copy.unavailable);
    submit.disabled=true;
  } else submit.disabled=false;
  form.addEventListener('submit',async event=>{
    event.preventDefault();
    if(sending||sent||!csrf||!api)return;
    if(!form.reportValidity())return;
    const values=Object.fromEntries(new FormData(form));
    values.agreeToTerms=form.elements.agreeToTerms.checked;
    if(brand?.value){values.message=(values.message.trim()||(values.contactMethodPreference==='Email'?copy.requestEmail:copy.requestPhone).replace('{topic}',values.topic))+'\n'+copy.brandPrefix+(brand.value==='Other'?copy.otherBrand:brand.value);}
    const created=api.createPayload(values);
    if(!created.ok){
      const [name,message]=Object.entries(created.errors)[0];
      const field=form.elements[name];
      show(message,true);
      if(field?.setCustomValidity){field.setCustomValidity(message);field.reportValidity();}
      return;
    }
    const requestLocation=locations[values.location];
    sending=true;submit.disabled=true;submit.textContent=copy.sending;
    const result=await api.submit(created.payload,csrf);
    sending=false;
    if(result.ok){
      sent=true;show((values.contactMethodPreference==='Email'?copy.successEmail:copy.successPhone).replace('{location}',requestLocation.name));
      submit.textContent=copy.sent;form.querySelectorAll('input,select,textarea').forEach(field=>field.disabled=true);
    }else{
      show(copy.unknown.replace('{phone}',requestLocation.phone),true);
      submit.disabled=false;label();
    }
  });
})();
